import { pushEvent } from '../helpers.js';

const pushDrawerEventToDataLayer = ({ siteFeature , interactionType  })=>{
    pushEvent({
        event: 'drawer_trigger_click',
        site_feature: siteFeature,
        interaction_type: interactionType
    });
};
const pushDrawerFilterEventToDataLayer = ({ siteFeature , interactionType  })=>{
    pushEvent({
        event: 'filter_interaction',
        site_feature: siteFeature,
        interaction_type: interactionType
    });
};

export { pushDrawerEventToDataLayer, pushDrawerFilterEventToDataLayer };
//# sourceMappingURL=drawer.js.map
